/* unplugin-vue-components disabled */import script from "./Dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=b7a2d570&scoped=true&lang=css"
import "./Dialog.vue?vue&type=style&index=1&id=b7a2d570&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7a2d570"]])

export default __exports__